var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 694,
    height: 969,
    viewBox: "0 0 694 969",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_150)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 694,
    height: 969,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.64 205.89H184.31C184.085 205.891 183.862 205.848 183.654 205.763C183.446 205.677 183.257 205.551 183.098 205.392C182.938 205.233 182.813 205.044 182.727 204.836C182.642 204.628 182.598 204.405 182.6 204.18C182.6 203.726 182.78 203.292 183.1 202.971C183.421 202.65 183.856 202.47 184.31 202.47H202.64C203.093 202.47 203.528 202.65 203.849 202.971C204.169 203.292 204.35 203.726 204.35 204.18C204.351 204.405 204.308 204.628 204.222 204.836C204.137 205.044 204.011 205.233 203.852 205.392C203.693 205.551 203.504 205.677 203.296 205.763C203.088 205.848 202.865 205.891 202.64 205.89Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M734 0H0V1216H734V0Z",
    fill: "#004276"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_287_150",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 734,
    height: 1216
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M734 0H0V1216H734V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_287_150)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3,
    d: "M-139 807.815C-105.14 767.885 -49.5665 742.561 2.3479 754.584C38.2169 762.919 69.9013 782.695 102.59 799.452C135.279 816.208 171.195 830.496 207.638 826.43C287.459 817.515 337.699 726.705 416.731 712.475C500.832 697.345 588.376 774.361 666.81 740.354C723.483 715.815 751.556 640.455 812.39 630V1021.35H-139V807.815Z",
    fill: "url(#paint0_linear_287_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.45,
    d: "M-64.8706 837.03C-21.0386 845.742 3.25664 836.769 39.6757 812.897C64.1144 796.838 84.7511 773.983 113.805 767.071C149.387 758.621 186.189 776.858 213.617 799.19C241.044 821.522 264.335 848.879 296.57 865.054C363.525 898.567 449.228 873.418 509.536 830.728C535.625 812.229 559.227 790.594 587.635 775.232C616.043 759.869 651.41 751.302 682.353 761.873C707.796 770.585 726.52 790.71 750.767 801.891V1085.47H-64.8706V837.03Z",
    fill: "url(#paint1_linear_287_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6,
    d: "M750.863 189.509C707.031 172.085 682.736 190.003 646.34 237.426C621.878 269.371 601.241 314.616 572.092 328.352C536.51 345.138 499.732 308.924 472.28 264.608C444.828 220.292 421.561 165.87 389.327 133.926C322.371 67.3646 236.692 117.285 176.361 202.055C150.272 238.704 126.694 281.684 98.2618 312.177C69.8296 342.669 34.5105 359.658 3.5675 338.691C-21.8995 321.441 -40.6231 281.452 -64.8706 259.294V-73.9468H750.863V189.509Z",
    fill: "url(#paint2_linear_287_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6,
    d: "M-18.002 148.736C31.6886 135.291 59.236 149.143 100.509 185.879C128.224 210.564 151.611 245.703 184.682 256.361C225.023 269.371 266.726 241.289 297.837 206.992C328.947 172.695 355.227 130.499 391.885 105.669C467.76 54.0931 564.942 92.7461 633.404 158.465C663.007 186.896 689.742 220.176 721.881 243.844C754.019 267.512 794.169 280.639 829.249 264.376C858.111 251.017 879.322 220.031 906.821 202.839V22.7874H-18.002V148.736Z",
    fill: "url(#paint3_linear_287_150)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.544 261.355C108.544 262.655 108.226 263.925 107.631 265.005C107.037 266.085 106.191 266.926 105.202 267.422C104.213 267.918 103.125 268.046 102.076 267.79C101.028 267.535 100.065 266.907 99.3098 265.986C98.5549 265.065 98.0421 263.893 97.8363 262.618C97.6305 261.343 97.7409 260.022 98.1536 258.824C98.5663 257.625 99.2627 256.602 100.155 255.884C101.046 255.167 102.094 254.787 103.164 254.792C104.593 254.8 105.961 255.495 106.969 256.725C107.978 257.955 108.544 259.62 108.544 261.355Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M505.566 895.631C505.566 896.929 505.249 898.198 504.656 899.277C504.062 900.356 503.218 901.197 502.23 901.694C501.243 902.191 500.156 902.321 499.108 902.068C498.059 901.814 497.096 901.189 496.341 900.271C495.585 899.354 495.07 898.184 494.862 896.911C494.653 895.638 494.76 894.318 495.169 893.119C495.578 891.92 496.271 890.895 497.16 890.174C498.048 889.452 499.093 889.067 500.162 889.067C501.595 889.067 502.97 889.759 503.983 890.99C504.997 892.221 505.566 893.89 505.566 895.631Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M602.891 894.701C606.153 894.701 608.797 891.49 608.797 887.528C608.797 883.566 606.153 880.355 602.891 880.355C599.629 880.355 596.984 883.566 596.984 887.528C596.984 891.49 599.629 894.701 602.891 894.701Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.24 216.459C115.244 217.242 115.057 218.01 114.701 218.664C114.346 219.318 113.838 219.828 113.243 220.131C112.648 220.433 111.992 220.514 111.359 220.363C110.726 220.211 110.144 219.834 109.688 219.28C109.232 218.726 108.921 218.02 108.797 217.251C108.672 216.482 108.738 215.686 108.987 214.963C109.237 214.24 109.657 213.623 110.196 213.192C110.734 212.76 111.366 212.532 112.011 212.538C112.867 212.538 113.689 212.951 114.294 213.686C114.899 214.422 115.24 215.419 115.24 216.459Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M589.859 946.422C589.859 947.205 589.667 947.969 589.309 948.62C588.951 949.27 588.441 949.776 587.846 950.074C587.25 950.372 586.595 950.448 585.963 950.294C585.332 950.139 584.752 949.76 584.299 949.205C583.845 948.649 583.537 947.943 583.414 947.175C583.291 946.407 583.359 945.612 583.609 944.891C583.859 944.169 584.279 943.555 584.817 943.124C585.355 942.694 585.986 942.467 586.631 942.473C587.056 942.473 587.478 942.575 587.871 942.774C588.265 942.973 588.622 943.264 588.922 943.631C589.222 943.998 589.459 944.434 589.62 944.913C589.781 945.392 589.862 945.905 589.859 946.422Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8666 243.147C40.9363 243.147 41.8035 242.094 41.8035 240.795C41.8035 239.496 40.9363 238.442 39.8666 238.442C38.7969 238.442 37.9297 239.496 37.9297 240.795C37.9297 242.094 38.7969 243.147 39.8666 243.147Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M658.918 676.839C658.918 677.304 658.805 677.759 658.592 678.145C658.379 678.532 658.077 678.834 657.723 679.012C657.369 679.19 656.979 679.236 656.603 679.146C656.228 679.055 655.883 678.831 655.612 678.502C655.341 678.173 655.156 677.754 655.082 677.298C655.007 676.841 655.045 676.368 655.192 675.938C655.338 675.509 655.587 675.141 655.905 674.883C656.224 674.624 656.598 674.486 656.981 674.486C657.493 674.494 657.982 674.744 658.344 675.184C658.706 675.623 658.912 676.217 658.918 676.839Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M234.492 952.23C234.492 952.684 234.381 953.127 234.174 953.505C233.966 953.882 233.671 954.176 233.326 954.35C232.981 954.523 232.601 954.569 232.234 954.48C231.868 954.392 231.531 954.173 231.267 953.852C231.003 953.532 230.823 953.123 230.75 952.678C230.677 952.233 230.715 951.771 230.858 951.352C231.001 950.933 231.243 950.575 231.553 950.323C231.864 950.071 232.229 949.936 232.603 949.936C233.104 949.936 233.584 950.178 233.939 950.608C234.293 951.038 234.492 951.622 234.492 952.23Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6817 910.296C57.6817 911.255 57.4475 912.193 57.0087 912.99C56.5699 913.788 55.9462 914.41 55.2165 914.777C54.4868 915.144 53.6838 915.24 52.9092 915.053C52.1345 914.866 51.423 914.404 50.8645 913.725C50.306 913.047 49.9256 912.183 49.7716 911.242C49.6175 910.301 49.6966 909.326 49.9988 908.44C50.3011 907.554 50.8129 906.796 51.4696 906.264C52.1263 905.731 52.8984 905.446 53.6882 905.446C54.7474 905.446 55.7631 905.957 56.512 906.867C57.2609 907.776 57.6817 909.01 57.6817 910.296Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M607.913 744.677C608.982 744.677 609.849 743.624 609.849 742.325C609.849 741.026 608.982 739.973 607.913 739.973C606.843 739.973 605.976 741.026 605.976 742.325C605.976 743.624 606.843 744.677 607.913 744.677Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.15
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M720.47 1257.01H723.77V-55.0706H720.47V20.4349H650.477V-55.0706H647.249V20.4349H577.161V-55.0706H573.861V20.4349H503.773V-55.0706H500.473V20.4349H430.576V-55.0706H427.252V20.4349H357.26V-55.0706H353.96V20.4349H283.968V-55.0706H280.668V20.4349H210.675V-55.0706H207.256V20.4349H137.359V-55.0706H134.059V20.4349H64.0665V-55.0706H60.7665V20.4349H-9.22592V-55.0706H-12.5259V1257.01H-9.22592V1181.51H60.7665V1257.01H64.0665V1181.51H134.059V1257.01H137.359V1181.51H207.256V1257.01H210.58V1181.51H280.668V1257.01H283.968V1181.51H353.96V1257.01H357.26V1181.51H427.252V1257.01H430.552V1181.51H500.545V1257.01H503.773V1181.51H573.765V1257.01H577.065V1181.51H647.249V1257.01H650.549V1181.51H720.541L720.47 1257.01ZM60.7665 1177.7H-9.22592V1092.55H60.7665V1177.7ZM134.059 1177.7H64.0665V1092.55H134.059V1177.7ZM207.256 1177.7H137.359V1092.55H207.256V1177.7ZM280.572 1177.7H210.675V1092.55H280.668L280.572 1177.7ZM353.864 1177.7H283.968V1092.55H353.96L353.864 1177.7ZM427.252 1177.7H357.26V1092.55H427.252V1177.7ZM500.545 1177.7H430.576V1092.55H500.569L500.545 1177.7ZM573.837 1177.7H503.773V1092.55H573.765L573.837 1177.7ZM647.249 1177.7H577.161V1092.55H647.249V1177.7ZM720.541 1177.7H650.477V1092.55H720.47L720.541 1177.7ZM60.7665 1088.52H-9.22592V1003.46H60.7665V1088.52ZM134.059 1088.52H64.0665V1003.46H134.059V1088.52ZM207.351 1088.52H137.359V1003.46H207.256L207.351 1088.52ZM280.668 1088.52H210.675V1003.46H280.668V1088.52ZM353.96 1088.52H283.968V1003.46H353.96V1088.52ZM427.276 1088.52H357.26V1003.46H427.252L427.276 1088.52ZM500.569 1088.52H430.576V1003.46H500.569V1088.52ZM573.861 1088.52H503.773V1003.46H573.765L573.861 1088.52ZM647.177 1088.52H577.161V1003.46H647.249L647.177 1088.52ZM720.47 1088.52H650.477V1003.46H720.47V1088.52ZM60.7665 999.509H-9.22592V914.507H60.7665V999.509ZM134.059 999.509H64.0665V914.507H134.059V999.509ZM207.351 999.509H137.359V914.507H207.256L207.351 999.509ZM280.668 999.509H210.675V914.507H280.668V999.509ZM353.96 999.509H283.968V914.507H353.96V999.509ZM427.276 999.509H357.26V914.507H427.252L427.276 999.509ZM500.569 999.509H430.576V914.507H500.569V999.509ZM573.861 999.509H503.773V914.507H573.765L573.861 999.509ZM647.177 999.509H577.161V914.507H647.249L647.177 999.509ZM720.47 999.509H650.477V914.507H720.47V999.509ZM60.7665 910.528H-9.22592V825.497H60.7665V910.528ZM134.059 910.528H64.0665V825.497H134.059V910.528ZM207.256 910.528H137.359V825.497H207.256V910.528ZM280.572 910.528H210.675V825.497H280.668L280.572 910.528ZM353.864 910.528H283.968V825.497H353.96L353.864 910.528ZM427.252 910.528H357.26V825.497H427.252V910.528ZM500.545 910.528H430.576V825.497H500.569L500.545 910.528ZM573.837 910.528H503.773V825.497H573.765L573.837 910.528ZM647.249 910.528H577.161V825.497H647.249V910.528ZM720.541 910.528H650.477V825.497H720.47L720.541 910.528ZM60.7665 821.49H-9.22592V736.459H60.7665V821.49ZM134.059 821.49H64.0665V736.459H134.059V821.49ZM207.351 821.49H137.359V736.459H207.256L207.351 821.49ZM280.668 821.49H210.675V736.459H280.668V821.49ZM353.96 821.49H283.968V736.459H353.96V821.49ZM427.276 821.49H357.26V736.459H427.252L427.276 821.49ZM500.569 821.49H430.576V736.459H500.569V821.49ZM573.861 821.49H503.773V736.459H573.765L573.861 821.49ZM647.177 821.49H577.161V736.459H647.249L647.177 821.49ZM720.47 821.49H650.477V736.459H720.47V821.49ZM60.7665 732.451H-9.22592V647.45H60.7665V732.451ZM134.059 732.451H64.0665V647.45H134.059V732.451ZM207.351 732.451H137.359V647.45H207.256L207.351 732.451ZM280.668 732.451H210.675V647.45H280.668V732.451ZM353.96 732.451H283.968V647.45H353.96V732.451ZM427.276 732.451H357.26V647.45H427.252L427.276 732.451ZM500.569 732.451H430.576V647.45H500.569V732.451ZM573.861 732.451H503.773V647.45H573.765L573.861 732.451ZM647.177 732.451H577.161V647.45H647.249L647.177 732.451ZM720.47 732.451H650.477V647.45H720.47V732.451ZM60.7665 643.355H-9.22592V558.44H60.7665V643.355ZM134.059 643.355H64.0665V558.44H134.059V643.355ZM207.256 643.355H137.359V558.44H207.256V643.355ZM280.572 643.355H210.675V558.44H280.668L280.572 643.355ZM353.864 643.355H283.968V558.44H353.96L353.864 643.355ZM427.252 643.355H357.26V558.44H427.252V643.355ZM500.545 643.355H430.576V558.44H500.569L500.545 643.355ZM573.837 643.355H503.773V558.44H573.765L573.837 643.355ZM647.249 643.355H577.161V558.44H647.249V643.355ZM720.541 643.355H650.477V558.44H720.47L720.541 643.355ZM60.7665 554.433H-9.22592V469.402H60.7665V554.433ZM134.059 554.433H64.0665V469.402H134.059V554.433ZM207.351 554.433H137.359V469.402H207.256L207.351 554.433ZM280.668 554.433H210.675V469.402H280.668V554.433ZM353.96 554.433H283.968V469.402H353.96V554.433ZM427.276 554.433H357.26V469.402H427.252L427.276 554.433ZM500.569 554.433H430.576V469.402H500.569V554.433ZM573.861 554.433H503.773V469.402H573.765L573.861 554.433ZM647.177 554.433H577.161V469.402H647.249L647.177 554.433ZM720.47 554.433H650.477V469.402H720.47V554.433ZM60.7665 465.394H-9.22592V380.393H60.7665V465.394ZM134.059 465.394H64.0665V380.393H134.059V465.394ZM207.351 465.394H137.359V380.393H207.256L207.351 465.394ZM280.668 465.394H210.675V380.393H280.668V465.394ZM353.96 465.394H283.968V380.393H353.96V465.394ZM427.276 465.394H357.26V380.393H427.252L427.276 465.394ZM500.569 465.394H430.576V380.393H500.569V465.394ZM573.861 465.394H503.773V380.393H573.765L573.861 465.394ZM647.177 465.394H577.161V380.393H647.249L647.177 465.394ZM720.47 465.394H650.477V380.393H720.47V465.394ZM60.7665 376.385H-9.22592V291.383H60.7665V376.385ZM134.059 376.385H64.0665V291.383H134.059V376.385ZM207.351 376.385H137.359V291.383H207.256L207.351 376.385ZM280.668 376.385H210.675V291.383H280.668V376.385ZM353.96 376.385H283.968V291.383H353.96V376.385ZM427.276 376.385H357.26V291.383H427.252L427.276 376.385ZM500.569 376.385H430.576V291.383H500.569V376.385ZM573.861 376.385H503.773V291.383H573.765L573.861 376.385ZM647.177 376.385H577.161V291.383H647.249L647.177 376.385ZM720.47 376.385H650.477V291.383H720.47V376.385ZM60.7665 287.376H-9.22592V202.345H60.7665V287.376ZM134.059 287.376H64.0665V202.345H134.059V287.376ZM207.351 287.376H137.359V202.345H207.256L207.351 287.376ZM280.668 287.376H210.675V202.345H280.668V287.376ZM353.96 287.376H283.968V202.345H353.96V287.376ZM427.276 287.376H357.26V202.345H427.252L427.276 287.376ZM500.569 287.376H430.576V202.345H500.569V287.376ZM573.861 287.376H503.773V202.345H573.765L573.861 287.376ZM647.177 287.376H577.161V202.345H647.249L647.177 287.376ZM720.47 287.376H650.477V202.345H720.47V287.376ZM60.7665 198.337H-9.22592V113.336H60.7665V198.337ZM134.059 198.337H64.0665V113.336H134.059V198.337ZM207.351 198.337H137.359V113.336H207.256L207.351 198.337ZM280.668 198.337H210.675V113.336H280.668V198.337ZM353.96 198.337H283.968V113.336H353.96V198.337ZM427.276 198.337H357.26V113.336H427.252L427.276 198.337ZM500.569 198.337H430.576V113.336H500.569V198.337ZM573.861 198.337H503.773V113.336H573.765L573.861 198.337ZM647.177 198.337H577.161V113.336H647.249L647.177 198.337ZM720.47 198.337H650.477V113.336H720.47V198.337ZM60.7665 109.328H-9.22592V24.3263H60.7665V109.328ZM134.059 109.328H64.0665V24.3263H134.059V109.328ZM207.351 109.328H137.359V24.3263H207.256L207.351 109.328ZM280.668 109.328H210.675V24.3263H280.668V109.328ZM353.96 109.328H283.968V24.3263H353.96V109.328ZM427.276 109.328H357.26V24.3263H427.252L427.276 109.328ZM500.569 109.328H430.576V24.3263H500.569V109.328ZM573.861 109.328H503.773V24.3263H573.765L573.861 109.328ZM647.177 109.328H577.161V24.3263H647.249L647.177 109.328ZM720.47 109.328H650.477V24.3263H720.47V109.328Z",
    fill: "white",
    fillOpacity: 0.42
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-115.231 1185.22L190.612 813.794",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.299 820.154C196.287 818.956 196.959 817.43 197.232 815.768C197.504 814.106 197.365 812.383 196.831 810.817C196.298 809.251 195.394 807.912 194.233 806.971C193.073 806.029 191.709 805.526 190.314 805.526C188.918 805.526 187.554 806.029 186.394 806.971C185.234 807.912 184.329 809.251 183.796 810.817C183.262 812.383 183.123 814.106 183.395 815.768C183.668 817.43 184.341 818.956 185.328 820.154C186.665 821.724 188.453 822.602 190.314 822.602C192.174 822.602 193.962 821.724 195.299 820.154Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M599.495 422.473L848.044 120.654",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M604.732 428.223C603.746 429.422 602.489 430.238 601.12 430.57C599.752 430.901 598.333 430.732 597.044 430.083C595.754 429.435 594.652 428.337 593.877 426.928C593.101 425.519 592.688 423.863 592.688 422.168C592.688 420.473 593.101 418.816 593.877 417.407C594.652 415.998 595.754 414.9 597.044 414.252C598.333 413.604 599.752 413.435 601.12 413.766C602.489 414.097 603.746 414.914 604.732 416.113C606.025 417.737 606.748 419.908 606.748 422.168C606.748 424.427 606.025 426.598 604.732 428.223Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M525.557 1177.12L774.082 875.302",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M567.62 1218.85L816.145 917.033",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M176.05 395.755L558.151 -68.2839",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M181.287 401.505C180.302 402.708 179.045 403.529 177.675 403.864C176.306 404.198 174.885 404.031 173.594 403.384C172.303 402.737 171.199 401.639 170.422 400.23C169.645 398.82 169.23 397.161 169.23 395.465C169.23 393.768 169.645 392.11 170.422 390.7C171.199 389.29 172.303 388.192 173.594 387.545C174.885 386.898 176.306 386.732 177.675 387.066C179.045 387.401 180.302 388.221 181.287 389.424C181.943 390.215 182.464 391.156 182.82 392.193C183.175 393.23 183.358 394.342 183.358 395.465C183.358 396.588 183.175 397.7 182.82 398.737C182.464 399.773 181.943 400.714 181.287 401.505Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M347.814 245.587L729.915 -218.453",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M353.123 251.307C352.137 252.506 350.88 253.323 349.511 253.654C348.143 253.985 346.724 253.816 345.435 253.168C344.145 252.52 343.043 251.422 342.268 250.013C341.492 248.604 341.079 246.947 341.079 245.253C341.079 243.558 341.492 241.901 342.268 240.492C343.043 239.083 344.145 237.985 345.435 237.337C346.724 236.689 348.143 236.52 349.511 236.851C350.88 237.182 352.137 237.999 353.123 239.198C354.416 240.822 355.139 242.993 355.139 245.253C355.139 247.512 354.416 249.683 353.123 251.307Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-62.6709 1223.15L159.024 953.915",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M158.761 962.773C162.657 962.773 165.815 958.937 165.815 954.206C165.815 949.474 162.657 945.639 158.761 945.639C154.865 945.639 151.707 949.474 151.707 954.206C151.707 958.937 154.865 962.773 158.761 962.773Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M555.353 948.281C555.353 952.246 554.384 956.121 552.57 959.417C550.756 962.713 548.178 965.281 545.161 966.797C542.145 968.312 538.826 968.707 535.625 967.932C532.424 967.156 529.484 965.245 527.177 962.44C524.871 959.635 523.301 956.061 522.667 952.173C522.033 948.284 522.363 944.254 523.616 940.593C524.868 936.932 526.987 933.804 529.703 931.606C532.42 929.408 535.612 928.237 538.877 928.243C543.249 928.251 547.439 930.365 550.528 934.122C553.617 937.879 555.353 942.972 555.353 948.281Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M538.877 987.544C556.785 987.544 571.302 969.913 571.302 948.165C571.302 926.416 556.785 908.786 538.877 908.786C520.969 908.786 506.451 926.416 506.451 948.165C506.451 969.913 520.969 987.544 538.877 987.544Z",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3015 365.756C72.4009 365.756 79.7774 356.798 79.7774 345.747C79.7774 334.697 72.4009 325.739 63.3015 325.739C54.2022 325.739 46.8257 334.697 46.8257 345.747C46.8257 356.798 54.2022 365.756 63.3015 365.756Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3011 385.126C81.2093 385.126 95.7267 367.496 95.7267 345.747C95.7267 323.999 81.2093 306.368 63.3011 306.368C45.3929 306.368 30.8755 323.999 30.8755 345.747C30.8755 367.496 45.3929 385.126 63.3011 385.126Z",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M585.076 138.398C580.993 141.056 576.352 142.185 571.74 141.642C567.128 141.098 562.753 138.906 559.166 135.344C555.58 131.781 552.943 127.007 551.591 121.625C550.238 116.243 550.229 110.495 551.565 105.107C552.901 99.7191 555.523 94.9331 559.098 91.3541C562.674 87.775 567.043 85.5634 571.653 84.9988C576.263 84.4343 580.907 85.5421 584.999 88.1822C589.091 90.8223 592.446 94.8763 594.641 99.8318C597.582 106.487 598.227 114.288 596.433 121.519C594.639 128.751 590.554 134.822 585.076 138.398Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M608.841 120.047C611.9 96.5701 598.707 74.527 579.376 70.8128C560.044 67.0985 541.893 83.1197 538.835 106.597C535.776 130.074 548.968 152.117 568.3 155.832C587.632 159.546 605.783 143.525 608.841 120.047Z",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_150",
    x1: 326.341,
    y1: 681.75,
    x2: 367.421,
    y2: 1068.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2390FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2390FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2390FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2390FF",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2390FF",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2390FF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2390FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_287_150",
    x1: 343.008,
    y1: 1085.47,
    x2: 343.008,
    y2: 757.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#2390FF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2390FF",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#2390FF",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2390FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#2390FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004276"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_287_150",
    x1: 342.984,
    y1: -74.0339,
    x2: 342.984,
    y2: 347.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_287_150",
    x1: 444.398,
    y1: 22.6422,
    x2: 444.398,
    y2: 271.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "white",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 694,
    height: 969,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.63bb26f0803c1ec9a7346dd4ee0f97cc.svg";
export { ForwardRef as ReactComponent };